// © Microsoft Corporation. All rights reserved.

export enum TelemetryTypes {
    Undefined = 0,
    Header = 1,
    Footer = 2,
    TopNavBar = 3,
    NavBar = 4,
    DropDown = 5,
    Section = 6,
    Carousel = 7,
    Module = 8,
    SearchBox = 9,
    InputBox = 10,
    ActionButton = 11,
    Interaction = 12,
    Headline = 13,
    Navigation = 14,
    Entity = 15,
    StructuredData = 16,
    AppStore = 17,
    AppLaunch = 18,
    CmsPromotions = 19,
    MicrosoftWebStore = 20,
    XboxStore = 21,
    OfficeStore = 22,
    AppInstall = 23,
    PartnerLinks = 24,
    SponsoredContent = 25,
    Follow = 26,
    Unfollow = 27,
    MoreFrom = 28,
    Topic = 29,
    Provider = 30,
    Spotlight = 33,
    Close = 36,
    Share = 37,
    Like = 38,
    Dislike = 39,
    Unlike = 40,
    Undislike = 41,
    Mute = 42,
    Unmute = 43,
    MuteCancel = 44,
    Manage = 45,
    NewStories = 46,
    AutoSuggest = 47,
    BingCard = 48,
    Tile = 49,
    TrendingNews = 50,
    AllCoverage= 51,
    Report = 52,
    AdChoice = 53,
    MsccCookieComplianceBanner = 54,
    Hide = 55,
    Unhide = 56,
    CookieWallCookieComplianceBanner = 57
}

export enum ContentTypes {
    StructuredData = 8
}